import { useState } from 'react';

import { type CategoryNode } from '../../category-tree';
import { type SubjectFormValues } from '../types';

export const useSelectSubjectNode = ({
  subjectNodeList,
  subjectFormValues,
}: {
  subjectNodeList?: CategoryNode[];
  subjectFormValues: SubjectFormValues;
}) => {
  const [selectedSubjectNode, setSelectedSubjectNode] = useState<
    CategoryNode | undefined
  >(
    () =>
      subjectNodeList?.find(node => node.nodeId === subjectFormValues.subject),
  );

  return [selectedSubjectNode, setSelectedSubjectNode] as const;
};
